<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业" prop="corpId">
              <j-dict-select-tag
                :disabled="corpDisAbled"
                dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
                placeholder="请选择企业"
                type="list"
                v-model="model.corpId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="充水量(吨)" prop="rechargeCount">
              <a-input-number
                :min="0"
                placeholder="请输入充水量(吨)"
                style="width: 100%"
                v-model="model.rechargeCount"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="充水量日期" prop="rechargeDate">
              <j-date placeholder="请选择充水量日期" style="width: 100%" v-model="model.rechargeDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付证明" prop="pictures">
              <j-upload :number="5" :returnUrl="false" bizPath="wfs/recharge" text="上传文件" v-model="model.pictures"></j-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import moment from "dayjs";

  export default {
    name: 'WfConsumerCorpRechargeForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          rechargeDate: moment().format('YYYY-MM-DD')
        },
        maxCharge: null,
        corpDisAbled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          rechargeCount: [
            { required: true, message: '请输入充水量(吨)!', },
            { validator: this.validateCount },
          ],
        },
        url: {
          add: "/wf/recharge/add",
          edit: "/wf/recharge/edit",
          queryById: "/wf/recharge/queryById",
          categoryList: "/custom/category/list"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      this.getMaxCharge();
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add (given) {
        if (given?.corpId) {
          this.corpDisAbled = true;
        }
        this.edit(Object.assign({}, this.modelDefault, given));
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      getMaxCharge () {
        getAction(this.url.categoryList, {
          code: 'A05A01'
        }).then(res => {
          if (res.result.records.length > 0) {
            const category = res.result.records.find(item => item.cusProp1 && item.cusProp1.toUpperCase() === 'MAX_CHARGE');
            if (category) {
              this.maxCharge = parseInt(category.cusProp2);
            }
          }
        })
      },
      validateCount (rule, value, callback) {
        if (value && this.maxCharge && value > this.maxCharge) {
          callback(new Error(`单次充水量不能大于${this.maxCharge}吨，可联系管理员修改设置。`));
        } else {
          callback();
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            if(this.model.pictures){
              this.model.pictures = JSON.stringify(this.model.pictures);
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>